import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { LayoutGrid, LayoutContainer } from 'utils/layouts';
import { Card, Form, Grid, Message, Tab } from 'semantic-ui-react';
import { Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { MAIN_COLOR } from 'containers/ChartPage/colors';
import { ErrorMessage } from 'utils/errors';
import { Padding, TopLabel } from 'components/Atoms';
import { NestedCancelIndicator } from 'components/Molecules';

import request from 'utils/request';
import Cookies from 'universal-cookie';
import {
  logoutSuccesful,
  showLoader,
  hideLoader,
} from 'containers/TopPage/actions';
import TimingDrugUsageForm from './forms/TimingDrugUsageForm';
import TreatmentResultsForm from './forms/TreatmentResultsForm';
import ImplementationForm from './forms/ImplementationForm';
import OpuSemenResultsForm from './forms/OpuSemenResultsForm';

const resultPane = (
  validateForm,
  updateFormValues,
  loadedData,
  presetData = null,
) => [
  {
    menuItem: '治療結果',
    render: () => (
      <Tab.Pane
        style={{ border: 'none', boxShadow: 'none', padding: 5 }}
        attached={false}
      >
        <TreatmentResultsForm
          isFormValid={validateForm}
          updateFormValues={updateFormValues}
          loadedData={loadedData ? loadedData.cycle : null}
          presetData={presetData ? presetData : null}
        />
      </Tab.Pane>
    ),
  },
];

const drugUsagePane = (validateForm, updateFormValues, loadedData) => [
  {
    menuItem: '薬剤',
    render: () => (
      <Tab.Pane
        style={{ border: 'none', boxShadow: 'none', padding: 5 }}
        attached={false}
      >
        <TimingDrugUsageForm
          otherDrugsLabel="血栓予防薬、ビタミン剤など"
          isFormValid={validateForm}
          updateFormValues={updateFormValues}
          loadedData={loadedData ? loadedData.medicine : null}
        />
      </Tab.Pane>
    ),
  },
];

const implementationPane = (validateForm, updateFormValues, loadedData) => [
  {
    menuItem: '人工授精実施',
    render: () => (
      <Tab.Pane
        style={{ border: 'none', boxShadow: 'none', padding: 5 }}
        attached={false}
      >
        <ImplementationForm
          mode={1}
          isFormValid={validateForm}
          updateFormValues={updateFormValues}
          loadedData={loadedData ? loadedData.aih : null}
        />
      </Tab.Pane>
    ),
  },
];

const semenResultsPane = (validateForm, updateFormValues, loadedData) => [
  {
    menuItem: '精液検査結果',
    render: () => (
      <Tab.Pane
        style={{ border: 'none', boxShadow: 'none', padding: 5 }}
        attached={false}
      >
        <OpuSemenResultsForm
          isFormValid={validateForm}
          updateFormValues={updateFormValues}
          loadedData={loadedData ? loadedData.semen : null}
        />
      </Tab.Pane>
    ),
  },
];

const InseminationCycle = ({
  location,
  logout,
  finishLoading,
  startLoading,
}) => {
  const cookies = new Cookies();
  const [registrationSuccess, setRegistrationSuccess] = useState(null);
  const [errors, setErrors] = useState([]);
  const [cycleId, setCycleId] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [loadedData, setLoadedData] = useState(null);
  const [presetData, setPresetData] = useState(null);
  const [formGroupValues, setFormGroupValues] = useState({});
  const [formStatus, setStatus] = useState([false, false, false]);
  const [hasNotChangeAnything, setHasNoChangeAnything] = useState(true);
  const validateForm = (index, newStatus) => {
    const newStatuses = formStatus.map(status => status);
    newStatuses[index] = newStatus;
    setStatus(newStatuses);
  };
  const updateFormValues = (index, formValues) => {
    setHasNoChangeAnything(false);
    const newValues = JSON.parse(JSON.stringify(formGroupValues));
    newValues[index] = formValues;
    setFormGroupValues(newValues);
  };
  useEffect(() => {
    const cookiesTemp = new Cookies();
    window.scrollTo(0, 0);
    if (location.pathname.match('/cycles/aihCycle/register')) {
      const url = `${process.env.REACT_APP_API_URL}/api/v1/all_cycle`;
      const promise = request(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          charset: 'UTF-8',
          Authorization: `Bearer ${cookiesTemp.get('user_token')}`,
        },
      });
      promise.then(response => {
        if (response.status === 401) logout();
        if (response.status === 503 || response.status === 500) {
          logout(response.status);
        }
        if (!response.has_cycle) return;
        setPresetData(response.latest_input_clinic);
      });
    }
    if (location.pathname.match('/cycles/aihCycle/edit/')) {
      const matches = location.pathname.match('/cycles/aihCycle/edit/(.*)');
      if (matches.length > 1) {
        setEditMode(true);
        const id = matches[1];
        setCycleId(id);
        const url = `${process.env.REACT_APP_API_URL}/api/v1/aih_cycles/${id}`;
        const promise = request(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            charset: 'UTF-8',
            Authorization: `Bearer ${cookiesTemp.get('user_token')}`,
          },
        });
        promise.then(response => {
          if (response.status === 401) logout();
          if (response.status === 503 || response.status === 500) {
            logout(response.status);
          }
          setLoadedData(response.data);
          setStatus([true, true, true]);
        });
      }
    }
  }, [location, logout]);
  if (registrationSuccess) {
    return <Redirect push to="/cycles?type=2" />;
  }
  const onRegisterCycle = evt => {
    evt.preventDefault();
    startLoading({ value: true });
    if (!editMode) {
      const url = `${process.env.REACT_APP_API_URL}/api/v1/aih_cycles`;
      const promise = request(url, {
        method: 'POST',
        body: JSON.stringify({ aih_cycle: formGroupValues }),
        headers: {
          'Content-Type': 'application/json',
          charset: 'UTF-8',
          Authorization: `Bearer ${cookies.get('user_token')}`,
        },
      });
      promise.then(response => {
        finishLoading({ value: true });
        if (response.status === 401) logout();
        if (response && !response.errors) setRegistrationSuccess(true);
        else {
          setErrors(response.errors);
        }
      });
    } else {
      const url = `${process.env.REACT_APP_API_URL}/api/v1/aih_cycles/${cycleId}`;
      const promise = request(url, {
        method: 'PATCH',
        body: JSON.stringify({ aih_cycle: formGroupValues }),
        headers: {
          'Content-Type': 'application/json',
          charset: 'UTF-8',
          Authorization: `Bearer ${cookies.get('user_token')}`,
        },
      });
      promise.then(response => {
        finishLoading({ value: true });
        if (response.status === 401) logout();
        if (response.status === 503 || response.status === 500) {
          logout(response.status);
        }
        if (response.status === 503 || response.status === 500) {
          logout(response.status);
        }
        if (response && !response.errors) setRegistrationSuccess(true);
        else {
          setErrors(response.errors);
        }
      });
    }
  };
  return (
    <LayoutContainer style={{ height: '100%' }}>
      <Padding paddingTop="14px" paddingBottom="14px" paddingLeft="14px">
        <NestedCancelIndicator />
      </Padding>
      <LayoutGrid>
        <Grid.Row columns={1} style={{ paddingTop: 0 }}>
          <Grid.Column mobile={16} computer={6} tablet={10}>
            <Card style={{ width: '100%' }} className="opu__card">
              <Card.Header>
                <Padding
                  paddingLeft="14px"
                  paddingBottom="14px"
                  paddingTop="14px"
                >
                  <TopLabel>人工授精</TopLabel>
                </Padding>
              </Card.Header>
              <Card.Content>
                <Form
                  style={{ width: '100%' }}
                  onSubmit={evt => {
                    onRegisterCycle(evt);
                  }}
                >
                  <Tab
                    panes={resultPane(
                      validateForm,
                      updateFormValues,
                      loadedData,
                      presetData,
                    )}
                    menu={{ secondary: true, pointing: true }}
                  ></Tab>
                  <Tab
                    panes={drugUsagePane(
                      validateForm,
                      updateFormValues,
                      loadedData,
                    )}
                    menu={{ secondary: true, pointing: true }}
                  ></Tab>
                  <Tab
                    panes={implementationPane(
                      validateForm,
                      updateFormValues,
                      loadedData,
                    )}
                    menu={{ secondary: true, pointing: true }}
                  ></Tab>
                  <Tab
                    panes={semenResultsPane(
                      validateForm,
                      updateFormValues,
                      loadedData,
                    )}
                    menu={{ secondary: true, pointing: true }}
                  ></Tab>

                  {errors.length > 0 && (
                    <Message negative>
                      <Message.Header>エラー</Message.Header>
                      {errors.map(error => (
                        <p key={error}>{error}</p>
                      ))}
                    </Message>
                  )}
                  <div
                    className="button_form_container"
                    style={{ display: 'flex', justifyContent: 'center' }}
                  >
                    <Form.Button
                      className="ninpath__form__container"
                      primary
                      style={{ minWidth: '80px', maxWidth: '120px' }}
                      disabled={!formStatus[0] || hasNotChangeAnything}
                    >
                      保存
                    </Form.Button>
                    {editMode && hasNotChangeAnything && (
                      <ErrorMessage color={MAIN_COLOR}>
                        項目に変更のない場合はボタンが押せません
                      </ErrorMessage>
                    )}
                    {!formStatus[0] && (
                      <ErrorMessage color={MAIN_COLOR}>
                        必須項目が未入力の場合はボタンが押せません
                      </ErrorMessage>
                    )}
                  </div>
                </Form>
              </Card.Content>
            </Card>
          </Grid.Column>
        </Grid.Row>
      </LayoutGrid>
    </LayoutContainer>
  );
};

const mapStateToProps = ({ CyclesReducer }) => ({
  registrationSuccess: CyclesReducer.registrationSuccess,
  errors: CyclesReducer.errors,
});

const mapDispatchToProps = dispatch => ({
  logout: (errorCode = null) => dispatch(logoutSuccesful(errorCode)),
  startLoading: payload => dispatch(showLoader(payload)),
  finishLoading: payload => dispatch(hideLoader(payload)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(InseminationCycle),
);
InseminationCycle.propTypes = {
  location: PropTypes.any.isRequired,
  logout: PropTypes.func.isRequired,
  startLoading: PropTypes.func.isRequired,
  finishLoading: PropTypes.func.isRequired,
};
